import { ArcElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, Tooltip } from 'chart.js';
import React from 'react';
import { Line } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, LineElement);

class ChartPayment extends React.Component {
    constructor(props) {
        super(props);
        this.chartRef = {};

        this.chartPaymentData = {
            labels: [],
            datasets: [
              {
                label: 'Flex Amortised',
                data: [],
                borderWidth: 2,
                backgroundColor: '#B13950',
                fill: true,
                borderColor: '#B13950',
                pointBorderWidth: 0,
                pointRadius: 1,
                stepped: true
                
              },
              {
                label: 'Flex Serial',
                data: [],
                borderWidth: 2,
                backgroundColor: '#726763',
                borderColor: '#726763',
                pointBorderWidth: 0,
                pointRadius: 1,
                stepped: true
              },
              {
                label: 'Advantage Amortised',
                data: [],
                borderWidth: 2,
                backgroundColor: '#4289AF',
                borderColor: '#4289AF',
                pointBorderWidth: 0,
                pointRadius: 1,
                stepped: true
              },
              {
                label: 'Advantage Serial',
                data: [],
                borderWidth: 2,
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
                borderColor: 'rgba(53, 162, 235, 0.5)',
                pointBorderWidth: 0,
                pointRadius: 1,
                stepped: true
              }
            ],
          };
        this.chartPaymentOptions = {
            responsive: true,
            plugins: {
              legend: {
                position: 'top'
              },
              tooltip: {
                callbacks: {
                  title: function(context) {
                    return 'Month: ' + context[0].label + ' / Year: ' + (context[0].label / 12).toFixed(0);
                  },
                  label: function(context) {
                      let label = context.dataset.label || '';

                      if (label) {
                          label += ': ';
                      }
                      if (context.parsed.y !== null) {
                          label += new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(context.parsed.y);
                      }
                      return label;
                  }
              }
              }
            },
            
            scales: {
              x: {
                title: {
                  display: false,
                  text: ''
                },
                min: 0,
                max: 500,
                ticks: {
                  autoSkip: false,
                  maxTicksLimit: 60,
                  //major: {enabled: true},
                  callback: function(tick, index, array) {
                    if (index % 60){
                      if(index === 12){
                        return (tick / 12) + " Year";
                      }
                      else{
                        return "";
                      }
                    }
                    else{
                      if(index === 0){
                        return "";
                      }
                        else{
                          return (tick / 12) + " Years";
                        }
                      
                    }
                  }
                }   
              },
              y: {
                ticks: {
                  // forces step size to be 50 units
                  stepSize: 200,
                  callback: function(tick, index, array) {
                    return "£ " + tick;
                  }
                }
              }


            }
          };
        
    }

    buildDatasets(){
      this.chartPaymentData.labels = [];
      this.chartPaymentData.datasets[0].data = [];
      this.chartPaymentData.datasets[1].data = [];
      this.chartPaymentData.datasets[2].data = [];
      this.chartPaymentData.datasets[3].data = [];
      if(this.props.competitorDisplay && this.props.competitorHasCalculation){
        this.chartPaymentData.datasets[4] = {
                label: 'Competitor',
                data: [],
                borderWidth: 2,
                backgroundColor: '#0B5240',
                borderColor: '#0B5240',
                pointBorderWidth: 0,
                pointRadius: 1,
                stepped: true,
                hidden: false
              };
        this.chartPaymentData.datasets[4].data = [];
      
      }
      else{
        if(this.chartPaymentData.datasets[4] !== undefined){
          this.chartPaymentData.datasets.pop();
        }
      }
      
      for(var a=0; a < this.props.calcData.flexAmortised.monthlyPayments.length; a++){
            var rowNumber = a;
            this.chartPaymentData.labels.push(rowNumber + 1);
            this.chartPaymentData.datasets[0].data[rowNumber] = Math.round(this.props.calcData.flexAmortised.monthlyPayments[a]);
            this.chartPaymentData.datasets[1].data[rowNumber] = Math.round(this.props.calcData.flexSerial.monthlyPayments[a]);
            this.chartPaymentData.datasets[2].data[rowNumber] = Math.round(this.props.calcData.advantageAmortised.monthlyPayments[a]);
            this.chartPaymentData.datasets[3].data[rowNumber] = Math.round(this.props.calcData.advantageSerial.monthlyPayments[a]);
            if(this.props.competitorDisplay && this.props.competitorHasCalculation){
              this.chartPaymentData.datasets[4].data[rowNumber] = Math.round(this.props.calcDataCompetitor.monthlyPayments[a]);
            }
      }
    }

    componentDidMount() {
        this.buildDatasets();
    }

    componentDidUpdate(prevProps) {
        this.buildDatasets();
        this.chartRef.data.labels = this.chartPaymentData.labels;
        this.chartRef.data.datasets = this.chartPaymentData.datasets;
        this.chartRef.update();
    }
    

  render() {
        return (<div className='mortgage-calculator__monthly-payment'>
            <h2>Monthly Payment</h2>
            <Line ref = {(reference) => this.chartRef = reference} options={this.chartPaymentOptions} data={this.chartPaymentData} />
        </div>);
    
    
  }

  
}

export default ChartPayment;